








import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component
export default class TitleCard extends Vue {
  @Prop({ required: true })
  public title!: string
}
